import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, NgForm, NgModel } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { LoadingSpinnerComponent } from '@mlc/shared/loading-spinner/loading-spinner.component';
import { AuthService } from '../../../../core/auth/auth.service';
import { FormFieldErrorComponent } from '../../../../shared/components/form-field-error/form-field-error.component';
import { AuthLayoutComponent } from '../auth-layout/auth-layout.component';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, LoadingSpinnerComponent, AuthLayoutComponent, FormFieldErrorComponent],
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent {
  email = '';
  isLoading = false;
  message = '';
  isError = false;

  constructor(private authService: AuthService, private router: Router) { }

  async onSubmit(form: NgForm): Promise<void> {
    if (form.invalid) {
      this.message = 'Please enter a valid email address.';
      this.isError = true;
      return;
    }

    this.isLoading = true;
    try {
      await this.authService.resetPassword(this.email);
      this.message = `Password reset link sent to ${this.email}.`;
      this.isError = false;
      // Redirect to login after a short delay to allow message to be seen
      setTimeout(() => {
        this.router.navigate(['/login']);
      }, 3000);
    } catch (error: any) {
      this.message = error.message || 'An unknown error occurred.';
      this.isError = true;
    } finally {
      this.isLoading = false;
    }
  }

  getErrors(control: NgModel): string[] {
    if (!control.invalid || !control.errors || (!control.dirty && !control.touched)) {
      return [];
    }

    const errors: string[] = [];
    if (control.errors['required']) {
      errors.push('This field is required.');
    }
    if (control.errors['email']) {
      errors.push('Please enter a valid email address.');
    }
    // Add more error types as needed
    return errors;
  }
}
